import { useRenderForm } from './use-render-form';
import { useRenderSubmit } from './use-render-submit';
import { useSeedManagement } from './use-seed-management';
import type { RenderCreateRequest } from '@/types/render';

interface UseRenderSettingsOptions {
  isDerivative?: boolean;
  onSubmit: (data: RenderCreateRequest) => Promise<void>;
  conceptAngleId?: string;
  projectId?: string;
}

// Primary hook for render settings - composed from specialized hooks
export function useRenderSettings({
  isDerivative = false,
  onSubmit,
  conceptAngleId,
  projectId,
}: UseRenderSettingsOptions) {
  // Use specialized hooks
  const form = useRenderForm();
  const submit = useRenderSubmit({
    isDerivative,
    onSubmit,
    conceptAngleId,
    projectId,
  });
  const seed = useSeedManagement();

  return {
    // State
    formData: form.formData,
    isSubmitting: submit.isSubmitting,

    // Handlers
    handleSubmit: submit.submitRender,
    handleSeedChange: seed.setSeed,
    handlePromptChange: form.setPrompt,
    handleControlsChange: form.setControls,

    // Actions
    generateRandomSeed: seed.generateRandomSeed,
    updateFormData: form.updateFormData,
  };
}
